;(function($, window, document, undefined) {
	var $win = $(window);
	var $doc = $(document);

	$doc.ready(function() {
		/**
		 * Hides an element and removes active classes from a trigger element and the `html` tag
		 *
		 * @param  {Object} event                    Event data
		 *
		 * @return {Void}
		 */

		function hideElementOnDocumentClick(event, clickHandler) {
			var $target = $(event.target);
			var $wrapper = $('.wrapper');
			var $html = $('html');


			var elementClass = clickHandler.elementClass;
			var triggerClass = clickHandler.triggerClass;
			var elementVisibleClass = clickHandler.elementVisibleClass;
			var triggerActiveClass = clickHandler.triggerActiveClass;
			var globalVisibleClass = clickHandler.globalVisibleClass;

			if (
				!$target.hasClass(elementClass) &&
				!$target.parents('.' + elementClass).length &&
				!$target.hasClass(triggerClass) &&
				!$target.parents('.' + triggerClass).length
				) {
					$('.' + elementClass).removeClass(elementVisibleClass);
					$('.' + triggerClass).removeClass(triggerActiveClass);

					$wrapper.removeClass(globalVisibleClass);
					$html.removeClass(globalVisibleClass);
				}
		}

		/**
		 * @param  {String} elementClass             Selector for the element to hide
		 * @param  {String} triggerClass             Selector for the trigger
		 * @param  {String} elementVisibleClass      Classname to remove from the element
		 * @param  {String} triggerActiveClass       Classname to remove from the trigger
		 * @param  {String} globalVisibleClass       Classname to remove from the `html` tag
		 */
		var clickHandlers = [
			{
				elementClass: 'search .field',
				triggerClass: 'search',
				elementVisibleClass: 'input-visible',
				triggerActiveClass: '',
				globalVisibleClass: ''
			}
		];

		$doc.on('click touchend', function(event) {
			clickHandlers.forEach(function(clickHandler) {
				hideElementOnDocumentClick(event, clickHandler);
			});
		});

		//Rsponsive dropdown
		$('.nav').on('click', '.menu-item-has-children > a', function(event) {
			if ($win.width() < 768) {
        if (!$(this).parent().hasClass('is-expanded')) {
					$(this).siblings('ul').stop().slideToggle().parent().toggleClass('is-expanded');
					event.preventDefault();
				}
			}
		});


		//Init Slider Logos
		$('.slider-intro .owl-carousel').owlCarousel({
			autoplay: false,
			loop: false,
			margin: 0,
			mouseDrag: false,
			touchDrag: false,
			startPosition: 2,
			items: 1,
			nav: false,
			navText: ''
			// smartSpeed: 1800,
		});

		//Show search field
		$('.search__btn').on('click', function(event){
			var input = $(this).prev();

			if( !input.hasClass('input-visible') ) {
				event.preventDefault();

				input.addClass('input-visible');
			}
		});

		//Check for dropdown
		$('.nav li').each(function() {
			var $this = $(this);
			var hasDropdown = $this.find('> .nav-menu').length;

			if (hasDropdown) {
				$this.addClass('has-dropdown');
			}
		});

		//Responsive navigation
		$('.nav-button').on('click', function(event) {
			event.preventDefault();

			$('.nav').toggleClass('is-visible');
			$(this).toggleClass('opened');
		});


		// Login Page

		if ($('.template-login').length > 0) {
			$('.link-forgot-password').on('click', function() {
				$('#btn-form-recover-password').attr('checked', 'checked').trigger('change').siblings('input').removeAttr('checked')
			})

			$('input').on('change', function() {
				$('input:checked').next('form').show().siblings().hide()
			})
		}

		// Collection Filter

		$('.bar__inner .select__inner').on('change', function(event) {
			window.location = $(this).val();
		})

		//Init Tabs

		var activeTabClass = 'current';

		$('.template-product .tabs__nav a, .template-alt .tabs__nav a').on('click', function(event) {
			event.preventDefault();

      $('.tabs__body').show();
      $('#buy_now').hide();

			var $tabLink = $(this);
			var $targetTab = $($tabLink.attr('href'));

			$tabLink
				.parent()
				.add($targetTab)
				.addClass(activeTabClass)
					.siblings()
					.removeClass(activeTabClass);
		});

		$('body').on('click', '.tabs__nav a', function(event) {
				var $tabLink = $(this);

				$tabLink.
					closest('li')
					.addClass(activeTabClass)
						.siblings()
						.removeClass(activeTabClass);

			if ( $('.template-product').length == 0 && $('.template-alt').length == 0 ) {
				event.preventDefault();

				$.ajax({
					url: $tabLink.attr('href'),
				})
				.done(function(data) {
					var $container = $('.section__body');

					$container.parent().html($(data).find('.section__body'));
				})
			}
		});

    $('body').on('click', '.btn_buy_now', function(event) {
      event.preventDefault();
      $('.tabs__body').hide();
      $('#buy_now').show();
      $('.tabs__nav li.current').removeClass('current');
    })

		$('body').on('change', '.tabs__select-outer select', function (event) {
			var $selectedOption = $(this).find('option:selected');

			$.ajax({
				url: $selectedOption.val(),
			})
			.done(function(data) {
				var $container = $('.section__body').parent();

				$container.html($(data).find('.section__body'));
			})
		})

    $('.form__body input[type="radio"], .form__body select').on('change', function() {
      var productData = '';
      var data = $(this).closest('form').find('input[type="radio"]:checked, select#field-license').each(function() {
        var $item = $(this);
        productData += '[data-'+  $item.attr('name') +'="'+ $item.val() +'"]';
      });

      var price = $('.product--original').find('option' + productData ).prop('selected', true).data('price');

      $('.variant_price').text(price);
    });

		// This number is magically chosen
		var navItemsSize = 13;

		function splitList($nav, size) {
			var temp = [];
			var markup = [];
			var $items = $nav.find('li');

			$items.unwrap();

			for ( var i = 0, j = $items.length; i < j; i += size ) {
				temp.push([].slice.call($items, i, i + size));
			}

			temp.forEach(function (item) {
				var html = '<ul>';

				item.forEach(function (el) {
					html += $.trim(el.outerHTML);
				});

				html += '</ul>';

				markup.push(html);
			});

			$nav.html(markup.concat());
		}

		function equalizeWidth($items, $parent, breakpoint) {
			$items.each(function() {
				var $item = $(this);

				if ( $win.width() < breakpoint ) {
					$item.removeAttr('style');
				} else {
					$item.innerWidth($parent.width() / $items.length);
				}
			});
		}

		function equalizeNavsWidth(breakpoint) {
			$('.nav-menu').each(function() {
				equalizeWidth($(this).find('ul'), $(this), breakpoint);
			});
		}

		$('.js-split').each(function() {
			splitList($(this), navItemsSize);
		});

		equalizeNavsWidth(1024);

		$win.on('resize', function() {
			equalizeNavsWidth(1024);
		});

	});
})(jQuery, window, document);
